import AbstractLazyLoad from './AbstractLazyLoad';
import LazyLoadElementWrapper from './LazyLoadElementWrapper';

export default class ImgLazyLoad extends AbstractLazyLoad {
  constructor() {
    super(':not(picture) > .img-lazyload');
  }

  protected load(wrapper: LazyLoadElementWrapper): void {
    /* const imgElement = wrapper.getElementAs<HTMLImageElement>();
    const { src, srcset } = imgElement.dataset;
    if (src) {
      imgElement.src = src;
      delete imgElement.dataset.src;
    }
    if (srcset) {
      imgElement.srcset = srcset;
      delete imgElement.dataset.srcset;
    } */
  }
}